import { createAction } from '@reduxjs/toolkit';

import { CreateSpecialTablePayload, LobbyRoom, MyTable, RecentTable } from '../types';

export const lobbyRoomsRequest = createAction<{
	start: number;
	limit: number;
}>('lobby/rooms/request');
export const lobbyRoomsSuccess = createAction<{
	items: LobbyRoom[];
	vipRoom: LobbyRoom | null;
	total?: number;
}>('lobby/rooms/success');
export const lobbyRoomsFailure = createAction<string>('lobby/rooms/failure');

export const activeUsersRequest = createAction('lobby/activeUsers/request');
export const activeUsersSuccess = createAction<{ count: number }>('lobby/activeUsers/success');
export const activeUsersFailure = createAction<string>('lobby/activeUsers/failure');

export const myTablesRequest = createAction('lobby/myTables/request');

export const myTablesSuccess = createAction<{
	items: MyTable[];
	recent: RecentTable[];
}>('lobby/myTables/success');

export const myTablesFailure = createAction<string>('lobby/myTables/failure');

export const createSpecialTableRequest = createAction<CreateSpecialTablePayload>(
	'lobby/createSpecialTableRequest',
);

export const createSpecialTableSuccess = createAction<{
	tableId: string | number;
	legacyRoomId?: number;
}>('lobby/createSpecialTableSuccess');

export const createSpecialTableFailure = createAction<string>('lobby/createSpecialTableFailure');

export const clearCreateTableError = createAction('lobby/clearCreateTableError');
